import { useCallback } from "react";
import { CellValueChangedEvent } from "ag-grid-community";
import { SYS3010_R01Dto } from "../Dto_SYS3010_R01";

interface UseSYS3010_R01CellChangeProps {
	updateSYS3010_R01List: (index: number, data: SYS3010_R01Dto) => void;
	originalSYS3010_R01List: SYS3010_R01Dto[];
}

export function useSYS3010_R01CellChange({
	updateSYS3010_R01List,
	originalSYS3010_R01List,
}: UseSYS3010_R01CellChangeProps) {
	const handleCellChange = useCallback(
		(event: CellValueChangedEvent<SYS3010_R01Dto>) => {
			const { data, colDef, newValue } = event;
			if (!data || !colDef.field) return;
			const field = colDef.field as keyof SYS3010_R01Dto;

			const updatedData: SYS3010_R01Dto = {
				...data,
				[field]: newValue as any,
				isModified: data.inserted ? false : true,
			};

			const originalRow = originalSYS3010_R01List.find((item) => item.valueIndex === data.valueIndex);
			if (originalRow && originalRow[field] === updatedData[field]) {
				updatedData.isModified = false;
			}

			updateSYS3010_R01List(data.valueIndex!, updatedData);
		}, [updateSYS3010_R01List, originalSYS3010_R01List]);

	return { handleCellChange };
}
